/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CampCategoryShowResponse2 } from '../../models/camp-category-show-response-2';

export interface DeleteCampCategoryRemove$Params {
  name: string;
}

export function deleteCampCategoryRemove(http: HttpClient, rootUrl: string, params: DeleteCampCategoryRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<CampCategoryShowResponse2>> {
  const rb = new RequestBuilder(rootUrl, deleteCampCategoryRemove.PATH, 'delete');
  if (params) {
    rb.path('name', params.name, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CampCategoryShowResponse2>;
    })
  );
}

deleteCampCategoryRemove.PATH = '/v1/camp-category/{name}';
